<!-- 多供应商采购>库存商品列表 -->
<template>
    <div id="goodSearch" class="business-content-main multi-supplier-purchase">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">自采类型</div>
                <el-select size="small" class="search-item" v-model="taskType" placeholder="自采类型">
                    <el-option key="5" label="自动采购" value="5"></el-option>
                    <el-option key="6" label="新品调拨" value="6"></el-option>
                    <el-option key="7" label="计划调拨" value="7"></el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                <el-button size="small" class="search-btn btn-primary" v-if="permission.stockPurchase" @click="gotoQuickBuy()">{{ permission.stockPurchase }}</el-button>
                <el-button size="small" class="search-btn" type="warning" @click="showCheckDialog(0)">自采校验</el-button>
                <el-button size="small" class="search-btn" type="warning" @click="showCheckDialog(1)">新品调拨校验</el-button>
                <el-button v-if="!isAutoRun" size="small" class="search-btn" type="primary" @click="showTaskDialog()">自采任务</el-button>
                <div v-if="warehousedId" class="search-name" style="color: red; font-size: 17px; font-weight: 600">当前主仓【{{ warehousedName }}】</div>
                <div v-if="taskType == 7" class="search-name" style="color: gray; font-size: 14px; font-weight: 600">
                    (计划调拨类型时：补货数 = 计划调拨数 - 计划采购数)
                </div>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    :cell-style="cellStyle"
                    @selection-change="handleSelectionChange"
                    @cell-dblclick="handleDBClick"
                    @sort-change="sortChange"
                >
                    <el-table-column fixed type="selection" width="55"></el-table-column>
                    <el-table-column min-width="200px" prop="APCode" label="汽配编码" show-overflow-tooltip sortable="custom"></el-table-column>
                    <el-table-column min-width="150px" prop="GoodName" label="汽配名称" show-overflow-tooltip sortable="custom"></el-table-column>
                    <el-table-column width="200px" prop="AutoSerise" label="适用车型" show-overflow-tooltip sortable></el-table-column>
                    <el-table-column width="80px" prop="CostPrice" label="成本价" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="Price" label="批发价" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="MarketPrice" label="零售价" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="UpperLimit" label="上限" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="LowerLimit" label="下限" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="FloatUL" label="浮动上限" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="FloatLL" label="浮动下限" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="80px" prop="Inventory" label="实际在仓" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="70px" prop="PlanPurchase" label="计划数" show-overflow-tooltip></el-table-column>
                    <el-table-column width="70px" prop="NeedIn" label="待入"></el-table-column>
                    <el-table-column width="70px" prop="NeedOut" label="待出"></el-table-column>
                    <el-table-column width="70px" label="留余">
                        <template slot-scope="scope">
                            <i class="out-active">{{ scope.row.Inventory - scope.row.NeedOut + (isAddWaitIn ? scope.row.NeedIn : 0) }}</i></template
                        ></el-table-column
                    >
                    <!-- <el-table-column width="70px" prop="TransInCount" label="调入数"></el-table-column> -->
                    <el-table-column width="70px" prop="NeedPurchase" label="补货数"></el-table-column>
                    <el-table-column min-width="100px" prop="Cate" label="汽配分类" show-overflow-tooltip></el-table-column>
                    <el-table-column min-width="120" prop="Brand" label="品牌" show-overflow-tooltip sortable="custom"></el-table-column>
                    <el-table-column min-width="100" prop="Unit" label="单位" show-overflow-tooltip sortable="custom"></el-table-column>
                    <el-table-column min-width="100" prop="Quality" label="重量" show-overflow-tooltip sortable="custom"></el-table-column>
                    <el-table-column min-width="100" prop="Size" label="尺寸" show-overflow-tooltip sortable="custom"></el-table-column>
                    <el-table-column min-width="100" prop="Texture" label="材质" show-overflow-tooltip sortable="custom"></el-table-column>
                    <el-table-column min-width="100" prop="Color" label="颜色" show-overflow-tooltip sortable="custom"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <img class="image-cus" src="@/assets/images/cus.png" title="销售历史" @click="showSaleStat(scope.row)" />
                                <img
                                    src="@/assets/images/analysis.png"
                                    style="width: 22px; height: 22px; margin-left: 6px"
                                    title="数据分析"
                                    @click="analysis(scope.row)"
                                />
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50, 200]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="closeAPMsgDialog"> </APMsg>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body width="1200px">
            <div v-if="eyeHistoryVisible">
                <APHistory :showCusColumn="false" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="eyeHistoryVisible = false"></APHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" width="1200px">
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis :GoodsId="EntpTempGoodsId" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="自采商品校验" @close="closeCheckDialog" :visible.sync="showCheck" width="500px">
            <div class="dialog-content" v-if="showCheck">
                <CheckAutoPur></CheckAutoPur>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="新品调拨校验" @close="closeCheckDialog" :visible.sync="showTransCheck" width="500px">
            <div class="dialog-content" v-if="showTransCheck">
                <CheckAutoTrans></CheckAutoTrans>
            </div>
        </el-dialog>
        <!-- 手动创建自动采购历史 -->
        <el-dialog title="手动创建自动采购数据" :close-on-click-modal="false" :visible.sync="taskHistoryVisible" append-to-body width="1200px">
            <div v-if="taskHistoryVisible">
                <TaskHistory @closeDialog="taskHistoryVisible = false"></TaskHistory>
            </div>
        </el-dialog>

        <el-dialog
            :close-on-click-modal="false"
            title="自动采购搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-page-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item label="汽配编码">
                        <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="汽配编码"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.GoodName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入配件名称"
                            :remote-method="searchGoodName"
                            v-select-scroll-more="searchGoodNameLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="适用车型">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.AutoSerise"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入车型"
                            :remote-method="searchAutoSerise"
                            v-select-scroll-more="searchAutoSeriseLoad"
                            popper-class="my-select"
                        >
                            <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item" style="width: 300px"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="过滤类型">
                        <el-select size="small" class="search-item" v-model="searchData.FilterType" placeholder="请选择">
                            <el-option key="自采无供应商" label="自采无供应商" value="0"></el-option>
                            <el-option key="全部商品" label="全部商品" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import APMsg from '@/components/common/APMsg';
import APHistory from '@/components/common/APHistory';
import TaskHistory from '@/components/common/taskHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import CheckAutoPur from '@/components/business/purManage/checkAutoPur';
import CheckAutoTrans from '@/components/business/purManage/checkAutoTrans';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'goodSearch',
    components: {
        APMsg,
        elTableColumn,
        APHistory,
        goodsAnalysis,
        breadcrumb,
        CheckAutoPur,
        TaskHistory,
        CheckAutoTrans
    },
    data() {
        return {
            dialogVisible: false,
            multipleSelection: [],
            brand: [],
            noData: false,
            typeList: [],
            goodsType: '',
            APMsgVisible: false,
            EntpTempGoodsId: '',
            showSaleStatDialog: false,
            eyeHistoryVisible: false,
            goodsAnalysisVisible: false,
            SaleDialogTitle: '',
            historyVisible: false,
            searchData: {
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                Cate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                FilterType: '0',
                limit: this.commonPageSize
            },
            taskType: '5',
            tableData: [],
            tableDataLength: 0,
            permission: {},
            isAddWaitIn: true,
            warehousedId: '',
            warehousedName: '',
            showCheck: false,
            showTransCheck: false,
            isAutoRun: true,
            taskHistoryVisible: false,
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.getStayCalValue();
        this.getTableData();
        this.getAutoRunSet();
        this.permission = this.$util.getPermission('autoPurchase');
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                that.dialogVisible = true;
            }
            if (key === 27) {
                if (that.dialogVisible) that.dialogVisible = false;
            }
            if (key === 13) {
                that.handleSearch();
                return;
            }
            debugger
            //左键
            if (key == 37) {
                if (this.searchData.page > 1) {
                    this.searchData.Page -= 1;
                    this.getTableData();
                }
                return;
            }
            //右键
            if (key == 39) {
                if (this.searchData.page < Math.ceil(this.tableDataLength / this.searchData.limit)) {
                    this.searchData.page += 1;
                    this.getTableData();
                }
                return;
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 单元格的 style 的回调方法
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (column.label === '操作') {
                return `background:#FFF;`;
            } else {
                return '';
            }
        },
        gotoQuickBuy() {
            let that = this;
            if (that.warehousedId) {
                if (!that.multipleSelection[0]) {
                    that.$router.push('/purchaseManage/autoPurchaseEdit?whId=' + that.warehousedId + '&whName=' + that.warehousedName);
                    return;
                }
                let dataList = [];
                for (var i = 0; i < that.multipleSelection.length; i++) {
                    let data = { ...that.multipleSelection[i] };
                    data.Price = data.CostPrice; //字段转化，方便编辑页面处理
                    data.EntpCusItem = '';
                    data.LatelyPrice = 0;
                    data.Count = data.NeedPurchase;
                    data.GoodNameItem = data.GoodName;
                    data.AutoSeriseItem = data.AutoSerise;
                    dataList.push(data);
                }
                that.$util.setLocalStorage('AddAutoPurOrders_dataList', dataList);
                that.$router.push('/purchaseManage/autoPurchaseEdit?whId=' + that.warehousedId + '&whName=' + that.warehousedName);
            } else that.$util.warningMsg('您未设置主仓！请先设置主仓');
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        searchGoodsType() {
            this.$util
                .getEntpApCategoryList()
                .then(data => {
                    if (!data) return;
                    this.typeList = data;
                })
                .catch(() => {});
        },
        // 重置表单
        resetSearch() {
            this.goodsType = '';
            this.searchData = {
                AutoSerise: '',
                APCode: '',
                BrandName: '',
                GoodName: '',
                Cate: '',
                SortProp: '',
                SortType: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        // 选中汽配分类
        chooseNode(data) {
            if (data) {
                this.goodsType = data.Item.Name;
                this.searchData.CascadeId = data.Item.CascadeId;
            } else {
                this.goodsType = '';
                this.searchData.CascadeId = '';
            }
        },
        // 获取数据
        getTableData() {
            let that = this;
            let url = '';
            if (that.taskType == '6') url = '/api/EntpPurchaseOrder/GetTransPurPartList';
            else if (that.taskType == '7') url = '/api/EntpPurchaseOrder/GetPlanTransPurList';
            else url = '/api/EntpPurchaseOrder/GetAutoPurPartList';
            that.$util
                .axiosGet({
                    url: url,
                    data: that.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        that.noData = true;
                        return;
                    }
                    that.noData = false;
                    that.tableData = data.DataList;
                    that.tableDataLength = res.count;
                    that.warehousedId = data.WarehousedId;
                    that.warehousedName = data.WarehousedName;
                })
                .catch(() => {});
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.EntpTempGoodsId) {
                this.EntpTempGoodsId = event.EntpTempGoodsId;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog() {
            this.APMsgVisible = false;
        },
        //当汽配品牌下拉框出现时触发
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        //当汽配分类下拉框出现时触发
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        //销售数据
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.EntpTempGoodsId = row.EntpTempGoodsId;
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.EntpTempGoodsId = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        //获取留余的计算方式
        getStayCalValue() {
            this.$util.getSysConfig('lybsdr').then(res => {
                this.isAddWaitIn = !res.Result;
            });
        },
        getAutoRunSet() {
            this.$util.getSysConfig('zdcgsp').then(res => {
                this.isAutoRun = res.Result;
            });
        },
        showCheckDialog(type) {
            if (type == 0) {
                this.showCheck = true;
                this.showTransCheck = false;
            } else if (type == 1) {
                this.showCheck = false;
                this.showTransCheck = true;
            }
        },
        closeCheckDialog() {
            if (this.showCheck) this.showCheck = false;
            if (this.showTransCheck) this.showTransCheck = false;
        },
        showTaskDialog() {
            this.taskHistoryVisible = true;
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        showSearchDialog() {
            this.dialogVisible = true;
        }
    }
};
</script>
<style lang="less" scoped>
.qp-msg {
    padding-bottom: 10px;

    p {
        padding-top: 10px;
    }
}

.qp-ctn {
    display: flex;
    flex-wrap: wrap;
}

.qp-item {
    width: 250px;
    margin-right: 20px;
    margin-bottom: 20px;
}

.qp-cover {
    text-align: center;
    overflow: hidden;

    img {
        max-height: 218px;
        max-width: 218px;
    }
}

.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .image-sup {
        width: 25px;
        height: 25px;
        margin-right: 4px;
    }

    .image-cus {
        width: 25px;
        height: 25px;
    }
}

@media screen and (max-width: 1675px) {
    .table-ctn {
        height: calc(100% - 162px);
        overflow-y: auto;
    }
}

@media screen and (min-width: 1675px) {
    .table-ctn {
        height: calc(100% - 98px);
        overflow-y: auto;
    }
}
</style>
<style lang="less">
.multi-supplier-purchase {
    .el-table {
        .hover-row > td,
        .el-table__row:hover > td {
            background-color: #dcdee1;
        }
    }

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

    .el-table .error-row {
        background: rgb(255, 176, 176);
    }
}
</style>
